import axios, { AxiosError } from "axios";
import { getToken, clearToken } from "@/lib/auth";

export const API_BASE = "https://autogen.yunwoai.com/api";
// "https://autogen.yunwoai.com/api";
// "http://localhost:8080/api";

const client = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: 20000,
});

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export class HttpError extends Error {
  status: number;
  data: any;

  constructor(message: string, status: number, data: any) {
    super(message);
    this.status = status;
    this.data = data;
  }
}

function mapAxiosError(error: unknown): never {
  if (axios.isAxiosError(error)) {
    const err = error as AxiosError<any>;
    const status = err.response?.status || 500;
    const data = err.response?.data;
    if (status === 401) {
      clearToken();
    }
    throw new HttpError(data?.error || data?.msg || err.message || "请求失败", status, data);
  }
  throw new HttpError("网络错误", 500, null);
}

export async function get<T = any>(url: string, params?: Record<string, any>): Promise<T> {
  try {
    const resp = await client.get(url, { params });
    return resp.data;
  } catch (error) {
    mapAxiosError(error);
  }
}

export async function post<T = any>(url: string, data?: Record<string, any>): Promise<T> {
  try {
    const resp = await client.post(url, data || {});
    return resp.data;
  } catch (error) {
    mapAxiosError(error);
  }
}

export async function put<T = any>(url: string, data?: Record<string, any>): Promise<T> {
  try {
    const resp = await client.put(url, data || {});
    return resp.data;
  } catch (error) {
    mapAxiosError(error);
  }
}
